<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>用户辅料配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">用户姓名:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.realName"
                size="small"
                @keyup.enter.native="searchCustomer"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row" :offset="1">
            <div class="query-title">用户id:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.userName"
                size="small"
                @keyup.enter.native="searchCustomer"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="11" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">

              <el-button class="search-btn btn-gray" @click="clearConditions"
                >重置</el-button
              >
              <el-button class="search-btn btn-blue" @click="searchCustomer"
              >搜索</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
        :data="customerList"
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        border
        height="550">
          <el-table-column type="index" align="center" label="序号" width="40">
          </el-table-column>
          <el-table-column prop="realName" label="用户姓名">
          </el-table-column>
          <el-table-column prop="userName" label="用户Id">
          </el-table-column>
          <el-table-column prop="paperLabelCount" align="center" label="纸标签">
          </el-table-column>
          <el-table-column prop="signCount" align="center" label="领标">
          </el-table-column>
          <el-table-column prop="washingMark" align="center" label="水洗标">
          </el-table-column>
          <el-table-column
            prop="accessoriesCount"
            align="center"
            label="商品附属品">
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                style="margin: 5px"
                class="list-btn btn-blue"
                @click="editCustomer(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <el-dialog
      title="附属品修改"
      :visible.sync="dialogVisible"
      width="30%"
      @close="AccessoriesDialogClose"
    >
      <el-form
        :model="customerAccessories"
        label-width="120px"
        class="add-role-form"
        :rules="dataRule"
        ref="accForm"
      >
        <el-form-item label="用户姓名：">
          <el-input
            v-model="customerAccessories.realName"
            size="small"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="用户Id：">
          <el-input
            v-model="customerAccessories.userName"
            size="small"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="纸标签：" prop="paperLabelCount">
          <el-input
            v-model.number="customerAccessories.paperLabelCount"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="领标：" prop="signCount">
          <el-input
            v-model.number="customerAccessories.signCount"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="水洗标：" prop="washingMark">
          <el-input
            v-model.number="customerAccessories.washingMark"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品附属品：" prop="accessoriesCount">
          <el-input
            v-model.number="customerAccessories.accessoriesCount"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeAccessoriesDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmEdit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
  name: 'userIngredients',
  // name: 'configuration/UserIngredients',
  components: { tableCon },
  data() {
    return {
      dataRule: {
        paperLabelCount: [
          { required: true, message: "纸标签数量不能为空", trigger: "blur" },
          { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        signCount: [
          { message: "领标数量不能为空", trigger: "blur", required: true },
          { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        washingMark: [
          { message: "水洗标数量不能为空", trigger: "blur", required: true },
          { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
        accessoriesCount: [
          {
            message: "商品附属品数量不能为空",
            trigger: "blur",
            required: true,
          },
          { type: "number", message: "必须为数字值", trigger: "blur" },
        ],
      },
      queryInfo: {
        userName: "",
        realName: "",
        pageSize: 10,
        pageNum: 1,
      },
      customerAccessories: {
        userId:"",
        userName: "",
        realName: "",
        paperLabelCount: 0,
        signCount: 0,
        washingMark: 0,
        accessoriesCount: 0,
      },
      customerList: [],
      total: 0,
      dialogVisible: false,
    };
  },
  methods: {
    searchCustomer() {
      this.queryInfo.pageNum = 1;
      this.getCustomerList();
    },
    confirmEdit() {
      var my = this;
      this.$refs.accForm.validate(async function (valid) {
        if (valid) {
          const { data: res } = await my.$http.post(
            "/customer/ingredients",
            my.customerAccessories
          );
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.dialogVisible = false;
            my.getCustomerList();
          } else {
            my.$message.error(res.message);
          }
        }
      });
    },
    closeAccessoriesDialog() {
      this.dialogVisible = false;
    },
    dialongInit() {
      this.customerAccessories.userId = "";
      this.customerAccessories.userName = "";
      this.customerAccessories.realName = "";
      this.customerAccessories.paperLabelCount = 0;
      this.customerAccessories.signCount = 0;
      this.customerAccessories.washingMark = 0;
      this.customerAccessories.accessoriesCount = 0;
    },
    AccessoriesDialogClose() {},
    editCustomer(row) {
      this.dialongInit();
      this.customerAccessories.userId = row.userId;
      this.customerAccessories.userName = row.userName;
      this.customerAccessories.realName = row.realName;
      this.customerAccessories.paperLabelCount = row.paperLabelCount;
      this.customerAccessories.signCount = row.signCount;
      this.customerAccessories.washingMark = row.washingMark;
      this.customerAccessories.accessoriesCount = row.accessoriesCount;
      let _this = this;
      this.$nextTick(function () {
        _this.$refs.accForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getCustomerList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getCustomerList();
    },
    clearConditions() {
      this.queryInfo.userName = "";
      this.queryInfo.userId = "";
      this.queryInfo.realName = "";
    },
    async getCustomerList() {
      const { data: res } = await this.$http.get("customer/customerList", {
        params: this.queryInfo,
      });
      this.customerList = res.data.list;
      this.total = res.data.total;
    },
  },

  created() {
    this.getCustomerList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
</style>
